import React from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import PropTypes from 'prop-types'
import withRoot from '../../withRoot'

const AlertDialog = props => {
  const { title, content, dismiss, affirm, redirect } = props
  const [open, setOpen] = React.useState(true)

  const handleDismiss = () => {
    setOpen(false)
  }

  const handleAffirm = () => {
    redirect ? (window.location.href = redirect) : null
    setOpen(false)
  }

  return (
    <Dialog
      open={open}
      onClose={handleDismiss}
      disableBackdropClick={true}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <DialogTitle id='alert-dialog-title'>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>
          {content}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {dismiss && (
          <Button onClick={handleDismiss} color='primary'>
            Cancel
          </Button>
        )}
        {affirm && (
          <Button onClick={handleAffirm} color='primary'>
            OK
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}

AlertDialog.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  dismiss: PropTypes.any,
  affirm: PropTypes.any
}

AlertDialog.defaultProps = {
  title: 'Dialog title',
  content: 'Dialog content',
  dismiss: false,
  affirm: true
}

export default withRoot(AlertDialog)
